const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const LANDING_DESCRIPTION_MAX = 1000;

export function validateLandingTestForm({
  name,
  email,
  phone,
  service,
  budget,
  description,
}) {
  const errors = {};
  const trimmedName = name.trim();
  const trimmedEmail = email.trim();
  const trimmedPhone = phone.trim();
  const trimmedService = service.trim();
  const trimmedBudget = budget.trim();
  const trimmedDescription = description.trim();

  if (!trimmedName) {
    errors.name = 'Il nome è obbligatorio.';
  } else if (trimmedName.length < 2) {
    errors.name = 'Inserisci almeno 2 caratteri.';
  }

  if (!trimmedEmail) {
    errors.email = 'L\'email è obbligatoria.';
  } else if (!EMAIL_RE.test(trimmedEmail)) {
    errors.email = 'Inserisci un indirizzo email valido.';
  }

  if (!trimmedPhone) {
    errors.phone = 'Il telefono è obbligatorio.';
  } else if (trimmedPhone.length < 6) {
    errors.phone = 'Inserisci un numero di telefono valido.';
  }

  if (!trimmedService) {
    errors.service = 'Il servizio richiesto è obbligatorio.';
  }

  if (!trimmedBudget) {
    errors.budget = 'Il budget è obbligatorio.';
  }

  if (!trimmedDescription) {
    errors.description = 'La descrizione è obbligatoria.';
  } else if (trimmedDescription.length < 20) {
    errors.description = 'Inserisci almeno 20 caratteri.';
  } else if (trimmedDescription.length > LANDING_DESCRIPTION_MAX) {
    errors.description = `Massimo ${LANDING_DESCRIPTION_MAX} caratteri.`;
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    values: {
      name: trimmedName,
      email: trimmedEmail,
      phone: trimmedPhone,
      service: trimmedService,
      budget: trimmedBudget,
      description: trimmedDescription,
    },
  };
}
